import React from 'react';
import {
    Box,
    Button,
    Drawer,
    DrawerBody,
    DrawerContent,
    DrawerHeader,
    DrawerOverlay,
    Menu,
    MenuButton,
    MenuItem,
    MenuList,
    Text,
    useDisclosure,
} from '@chakra-ui/react';
import {useRef} from 'react';
import {ChevronDownSvg} from '../../../assets';

const MenuKit = (props) => {
    const {buttonProps, options, activeItem} = props;
    const {isOpen, onOpen, onClose} = useDisclosure();
    const btnRef = useRef(null);
    return (
        <>
            <Box display={['none', 'flex']}>
                <Menu gutter={20} px={2}>
                    {({isOpen}) => (
                        <>
                            <MenuButton
                                as={Button}
                                mx={1}
                                rightIcon={
                                    <Box
                                        as={'span'}
                                        sx={{
                                            '& *': {
                                                fill: isOpen || buttonProps?.isActive ? '#F3F5F5' : '#353535',
                                            },
                                        }}
                                    >
                                        <ChevronDownSvg
                                            style={{
                                                transform: isOpen ? `rotate(0deg)` : `rotate(180deg)`,
                                            }}
                                        />
                                    </Box>
                                }
                                {...buttonProps}
                                isActive={isOpen}
                                _hover={{
                                    colot: 'white',
                                }}
                                sx={
                                    buttonProps?.isActive
                                        ? {bgColor: 'brand.700', color: 'white'}
                                        : undefined
                                }
                            >
                                {props.buttonProps?.children}
                            </MenuButton>
                            <MenuList maxH={550} overflow={'auto'}>
                                {options?.map(({title, value, ...item}, key) => (
                                    <MenuItem
                                        textColor={activeItem === value ? 'white' : undefined}
                                        key={key}
                                        {...item}
                                    >
                                        {title}
                                    </MenuItem>
                                ))}
                            </MenuList>
                        </>
                    )}
                </Menu>
            </Box>
            <Box display={['flex', 'none']}>
                <Button
                    isActive={isOpen}
                    rightIcon={
                        <Box
                            as={'span'}
                            sx={{
                                '& *': {
                                    fill: isOpen || buttonProps?.isActive ? '#F3F5F5' : '#353535',
                                },
                            }}
                        >
                            <ChevronDownSvg
                                style={{
                                    transform: isOpen ? `rotate(0deg)` : `rotate(180deg)`,
                                }}
                            />
                        </Box>
                    }
                    {...buttonProps}
                    ref={btnRef}
                    onClick={onOpen}
                >
                    {props.buttonProps?.children}
                </Button>

                <Drawer isOpen={isOpen} placement="bottom" onClose={onClose}>
                    <DrawerOverlay/>
                    <DrawerContent maxH={'60vh'} bgColor={'brand.700'} color={'white'}>
                        <DrawerBody>
                            <Box
                                sx={{
                                    '& p': {},
                                }}
                            >
                                {options?.map(({title, value, ...item}, key) => (
                                    <Text
                                        {...item}
                                        onClick={() => {
                                            onClose();
                                            item.onClick && item.onClick();
                                        }}
                                        py={'8px'}
                                        fontSize={'14px'}
                                        lineHeight={'5'}
                                        key={key}
                                        textColor={activeItem === value ? 'white' : undefined}
                                    >
                                        {title}
                                    </Text>
                                ))}
                            </Box>
                        </DrawerBody>
                    </DrawerContent>
                </Drawer>
            </Box>
        </>
    );
};

export default MenuKit;
